import create from "zustand";

// schema

export interface TeamsIntegrationStore {
	automaticSyncEnabled: boolean;
	setAutomaticSyncEnabled: (enabled: boolean) => void;

	numConnectedUsers: number;
	setNumConnectedUsers: (numConnectedUsers: number) => void;

	/**
	 * adminConsent indicates whether the performyard app has been granted
	 * the permission required to run "V1" of the Teams integration. This
	 * includes only a Feedback notifier and requires Team/channel permissions.
	 *
	 * adminConsentV2 indicates whether the performyard app has been granted
	 * the permission required to run "V2" of the Teams integration. This
	 * includes all of the permissions from "V1" plus extra permissions
	 * required to message and install in a users' personal scope.
	 *
	 * For our users, adminConsent allows use of the Feedback portion of the
	 * integrations and adminConsentV2 allows use of the Feedback and
	 * Notifications portions of the integration.
	 */
	adminConsent: {
		hasAdminConsent: boolean;
		hasAdminConsentV2: boolean;
	};
	setAdminConsent: (adminConsent: { hasAdminConsent: boolean; hasAdminConsentV2: boolean }) => void;
}

/**
 * This is the store for the Teams Integration management pages.
 */
const store = create<TeamsIntegrationStore>((set) => ({
	numConnectedUsers: 0,
	setNumConnectedUsers: (numConnectedUsers: number) => {
		set({ numConnectedUsers });
	},

	automaticSyncEnabled: false,
	setAutomaticSyncEnabled: (enabled: boolean) => {
		set({ automaticSyncEnabled: enabled });
	},

	adminConsent: {
		hasAdminConsent: false,
		hasAdminConsentV2: false,
	},
	setAdminConsent: (adminConsent: { hasAdminConsent: boolean; hasAdminConsentV2: boolean }) => {
		set({
			...{ adminConsent },
		});
	},
}));

export default store;
